
import { Component, Vue } from 'vue-property-decorator';
import { namespace, State } from 'vuex-class';
import { mmddyyyy } from '@kasasa/kloans-common-ui/dist/utils/date';
import { ProfileAccount } from '@/profile/types/profile-account';
import { ProfileFI } from '@/profile/types/profile-fi';
import { SessionUser } from '@/core/types/session-user';
import { ProfileHelper } from '@/profile/helper';

const profile = namespace('profile');
const session = namespace('session');

@Component({
	filters: {
		maskAccountNumber: ProfileHelper.maskAccountNumber,
		date: mmddyyyy,
	},
})
export default class ProfileAccounts extends Vue {
	@profile.State('accounts')
	public accounts!: ProfileAccount[];

	@profile.Getter('hasLoanAccounts')
	public hasLoanAccounts!: boolean;

	@profile.State('selectedInstitution')
	public selectedInstitution!: ProfileFI;

	@session.Getter('user')
	public user!: SessionUser;

	@State('backTo')
	public backTo!: object;

	public getAccountLink = ProfileHelper.getAccountLink;

	public showClosedAccounts = false;

	get visibleAccounts(): ProfileAccount[] {
		if (this.showClosedAccounts) {
			return this.accounts;
		}

		return this.accounts.filter((account) => account.closedDate === null);
	}

	get hasClosedAccounts() {
		return this.accounts.filter((account) => account.closedDate !== null).length > 0;
	}

	public toggleClosedAccounts() {
		this.showClosedAccounts = !this.showClosedAccounts;
	}
}
